// extracted by mini-css-extract-plugin
export default {"nfts-section":"Nfts_nfts-section__zfZ8Q","heading":"Nfts_heading__qaY04","nfts":"Nfts_nfts__HM7bg"};